import styled, { css } from 'styled-components'

import { TextInput } from '@vallourec-ui/vallourec-ui'

import { CustomTextInputProps } from '@/@types/global'
import {
  withColor,
  withFontSize,
  withMargin,
  withPadding,
} from '@/utils/styled-decorators'

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSizes['text-sm']};
  margin: 0;
  font-family: 'Noto Sans', sans-serif;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors['neutral-color-60']};
  vertical-align: middle;

  .message-icon {
    ${({ theme }) => css`
      min-width: ${theme.fontSizes.medium};
      width: ${theme.fontSizes.medium};
      min-height: ${theme.fontSizes.medium};
      height: ${theme.fontSizes.medium};
    `}
    margin-right: 8px;
  }
`

export const StyledTextInput = styled(TextInput)<CustomTextInputProps>`
  ${withMargin('8px 0px')}
  ${withColor('neutral-color-60')}
  ${withFontSize('medium')}
  ${withPadding('8px 16px')}
  width: 100%;
  flex: 1;
  min-height: 40px;
  align-items: stretch;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  font-size: ${({ theme }) => theme.fontSizes['text-md']};
  margin: 0;
  font-family: 'Roboto';
  transition: border 0.2s linear;
  ${({ success, theme }) =>
    success &&
    css`
      border: 2px solid ${theme.colors.success};
    `}
  ${({ warning, theme }) =>
    warning &&
    css`
      border: 2px solid ${theme.colors.warning};
    `}
  ${({ error, theme }) =>
    error &&
    css`
      border: 2px solid ${theme.colors.error};
    `}
  > div {
    width: 100%;
    align-items: stretch;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.lightGray};
  }
`

export const Label = styled.label`
  white-space: nowrap;
  margin-right: 8px;
`
